import {Add, Refresh, Visibility} from '@mui/icons-material';
import {IconButton, Tooltip} from '@mui/material';
import {reverse} from 'named-urls';
import qs from 'qs';
import * as React from 'react';
import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../../components/Services';
import Table from '../../../../components/Table';
import routes from '../../../../routes';
import AllocationSummary from '../../components/AllocationSummary';

const Jobs = ({company, loading, onLoading}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const [jobs, setJobs] = useState([]);
  const loaded = useRef(false);

  const loadJobs = useCallback(() => {
    onLoading(true);
    services.job.getJobs({filter: {company: company.id}}, 1, 500)
      .then(response => {
        onLoading(false);
        setJobs(response.data);
      }).catch(() => onLoading(false));
  }, [company, onLoading, services]);

  useEffect(() => {
    if (company) {
      if (!loaded.current) {
        loaded.current = true;
        loadJobs();
      }
    }
  }, [company, loadJobs]);

  const goToNew = useCallback(() => {
    const {id, name} = company;
    history.push({pathname: routes.jobs.new, search: `?${qs.stringify({company: {id, name}})}`});
  }, [history, company]);

  const goToDetail = useCallback((job) => {
    history.push(reverse(routes.jobs.detail, {id: job.id}));
  }, [history]);

  return (
    <Table className={loading ? 'loading' : ''}>
      <Table.Actions>
        <h3>Jobs</h3>
        <Tooltip title="Refresh">
          <IconButton onClick={() => loadJobs()}>
            <Refresh/>
          </IconButton>
        </Tooltip>
        <Tooltip title="Add New Job">
          <span>
            <IconButton disabled={company.archived} onClick={() => goToNew()}>
              <Add/>
            </IconButton>
          </span>
        </Tooltip>
      </Table.Actions>
      <Table.Row>
        <Table.Header>Reference</Table.Header>
        <Table.Header>Summary</Table.Header>
        <Table.Header>First Allocation</Table.Header>
        <Table.Action/>
      </Table.Row>
      {jobs.length > 0 ? (
        jobs.map((job, index) => (
          <Table.Row key={index}>
            <Table.Column>{job.reference}</Table.Column>
            <Table.Column>{job.summary} {job.model}</Table.Column>
            <Table.Column><AllocationSummary allocation={job.first_allocation}/></Table.Column>
            <Table.Action>
              <Tooltip title="View Job">
                <IconButton onClick={() => goToDetail(job)}>
                  <Visibility/>
                </IconButton>
              </Tooltip>
            </Table.Action>
          </Table.Row>
        ))
      ) : (
        loading ? null : <Table.NoRecords>There are no jobs associated with this company</Table.NoRecords>
      )}
    </Table>
  );
};

export default Jobs;
